module.exports = __webpack_public_path__ + "static/media/connect-wearables-thumbnail.485ffb08.jpg";